var crypto = require('crypto')

exports.createCipher = exports.Cipher = crypto.createCipher
exports.createCipheriv = exports.Cipheriv = crypto.createCipheriv
exports.createDecipher = exports.Decipher = crypto.createDecipher
exports.createDecipheriv = exports.Decipheriv = crypto.createDecipheriv
exports.listCiphers = exports.getCiphers = crypto.getCiphers



//////////////////
// WEBPACK FOOTER
// ./~/browserify-cipher/index.js
// module id = 477
// module chunks = 0 1 2 3